import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import GS1 from "./CobaSelidik/GS1";
import GS2 from "./CobaSelidik/GS2";
import GS3 from "./CobaSelidik/GS3";
import GS4 from "./CobaSelidik/GS4";
// import GS5 from "./CobaSelidik/GS5";

const Cobaselidik = () => {
    const [page, setPage] = useState(1);
	const nextPage = () => {
		if (page < 4) setPage(page + 1);
	};
	const previousPage = () => {
		if (page > 1) setPage(page - 1);
	};

	const rumus = () => {
		if (page === 1) {
			return <GS1 />;
		} else if (page === 2) {
			return <GS2 />;
		} else if (page === 3) {
			return <GS3 />;
		} else {
			return <GS4 />;
		} 
	};
	return (
		<div className="container">
			<div className="row align-items-start">
				<div className="col"></div>
				<div className="col">
					<div
						className="card mt-2 border-primary"
						style={{ width: "20rem", borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#4775d1", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 className="text-white text-center">Petunjuk Pengerjaan</h6>
						</div>
						<div className="card-body">
							<ol>
							<li>Pertama melengkapi semua form jawaban yang ada! </li>
                                <li>Apabila benar, maka border form akan berwarna hijau dan akan tampil form berikutnya! </li>
                                <li>Apabila salah, maka border form akan berwarna merah dan kalian harus menjawabnya sampai benar! </li>
								<li>Perhatikan dengan teliti perintah yang diberikan pada grafik!</li>
								<li>
									Selanjutnya kalian menentukan nilai optimumnya dengan cara
									menggeser slider yang tersedia untuk mendapatkan nilai
									optimumnya
								</li>
								<li>Ingat titik kordinatnya</li>

								<li>
									Kemudian isi form yang berupa harga optimum
									yang ditanyakan
								</li>
							</ol>
						</div>
					</div>
				</div>
				<div className="col"></div>
			</div>
            <div className="mt-2 mb-2">
                {rumus()}</div>
			<div className="row d-flex justify-content-center align-items-center">
				<div className="col-lg-10 mb-1  ">
					<div
						style={{
							marginTop: "1rem",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<button
							style={{ backgroundColor: "#4775d1" }}
							className="btn"
							onClick={() => previousPage()}
							disabled={page === 1 ? true : false}
						>
							<SkipPreviousIcon style={{ color: "white" }} />
						</button>
						<button
							style={{ backgroundColor: "#4775d1" }}
							className="btn"
							onClick={() => nextPage()}
							disabled={page === 4 ? true : false}
						>
							<SkipNextIcon style={{ color: "white" }} />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Cobaselidik;
